import {IColumnItem} from "@ui/tableCustom/types/columns";
import {HeadColumns} from "@ui/tableCustom/types/table";
import {copyObj} from "@helpers/transform/transform";
import {fillEmptyCellsMatrixPdf} from "@containers/export/containers/pdf/helpers/fillEmptyCellsMatrix";


interface IContentItem {
    text: unknown,
    style?: string,
    fillColor?: string,
    margin?: number[],
    bold?: boolean,
}

export const buildHeadColumns = <T>(headColumns: HeadColumns<T>): IContentItem[][] => {
    if (!headColumns?.length) {
        return []
    }

    const columnsWidthEmpty = fillEmptyCellsMatrixPdf(copyObj(headColumns) as IColumnItem<T>[][])

    return columnsWidthEmpty.map((col) => {
        return col.map((col) => {
            return {
                text: col.title,
                style: 'tableHeader',
                rowSpan: col.rowSpan,
                colSpan: col.colSpan
            }
        })
    })

}

export const buildHeaderColumnsPdf = <T>(columns: IColumnItem<T>[]): IContentItem[] => {
    return columns?.map((col) => {
        return {
            text: col['title'],
            "style": "tableHeader",
            "fillColor": "#2d4154",
            margin: [],
        }
    })
}